import { createStore } from 'react-sweet-state';

import { createCustomFormat, deleteCustomFormat, updateCustomFormat } from 'src/graphql/format';

const INITIAL_STATE = {
  savingFormat: false,
  deletingFormat: false,
};

/**
 * Public actions
 */
const ACTIONS = {
  createFormat:
    ({ brandVoiceId, format }) =>
    async ({ setState }) => {
      setState({ savingFormat: true });
      try {
        return await createCustomFormat({
          brandVoiceId,
          ...format,
        });
      } finally {
        setState({ savingFormat: false });
      }
    },

  updateFormat:
    (item) =>
    async ({ setState }) => {
      setState({ savingFormat: true });
      try {
        return await updateCustomFormat(item);
      } finally {
        setState({ savingFormat: false });
      }
    },

  deleteFormat:
    (id) =>
    async ({ setState }) => {
      setState({ deletingFormat: true });
      try {
        await deleteCustomFormat({ id });
      } finally {
        setState({ deletingFormat: false });
      }
    },
};

export const FormatStore = createStore({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: 'format-store',
});
